import React from "react";
import { useIsServer, usePageViewStyle } from "../../hooks";
import { getColors, getContainerClassPerMaxWidth } from "../../utils";
import { Container, ContainerFW } from "../global";
import { PlatformsReviewSwiper } from "./PlatformsReviewSwiper/PlatformsReviewSwiper";
import { PlatformsReviewColumns } from "./PlatformsReviewColumns/PlatformsReviewColumns";
import { LoadingSpinner } from "../LoadingSpinner";
const getContainerExtraClass = (containerMaxWidth) => {
    const containerMaxWidthClass = containerMaxWidth && getContainerClassPerMaxWidth(containerMaxWidth);
    return containerMaxWidthClass ? ` ${containerMaxWidthClass}` : "";
};
export const M40PlatformsReview = ({ reviews, backgroundColor, containerMaxWidth }) => {
    const { bgColor } = getColors(backgroundColor);
    const { isLarge } = usePageViewStyle();
    const isSSR = useIsServer();
    if (isSSR) {
        return (React.createElement("div", { className: "m40-platforms-review__loader" },
            React.createElement(LoadingSpinner, null)));
    }
    const containerExtraClass = getContainerExtraClass(containerMaxWidth);
    return (React.createElement(ContainerFW, { className: containerExtraClass, backgroundColor: bgColor },
        React.createElement(Container, { className: containerExtraClass },
            React.createElement("div", { className: "m40-platforms-review" },
                React.createElement("div", { className: "m40-platforms-review__swiper-wrapper" }, isLarge ? React.createElement(PlatformsReviewColumns, { reviews: reviews }) : React.createElement(PlatformsReviewSwiper, { reviews: reviews }))))));
};
